// import { Category } from "../../models/category";
export default {
    staffList: state => state.staffList,
    staffData: state => state.staffData,
    workingHours: state => state.workingHours,
    // workingHourById: (state) => id => state.workingHours.find((working_hour) => working_hour.employee_id == id),
    serviceList: state => state.serviceList,
    serviceData: state => state.serviceData,
    staffServiceList: state => state.staffServiceList,
    staffServiceData: state => state.staffServiceData,
    // activeStaff: (state, getters, rootState, rootGetters) => {
    //     return getters.staffList[0]
    // }
    checkinStaff: state => id => state.checkinStaff.find((staff) => staff.user_id == id),
    // themeColors: state => state.themeColors,
    // eslint-disable-next-line
    themeColors: (state, getters, rootState, rootGetters) => {
        if(rootGetters && rootGetters["auth/config"] && rootGetters["auth/config"].new_color == 1) {
            return state.themeNewColors;
        }
        return state.themeColors;
    },
    // themeColorsCate: state => state.themeColorsCate,
    // eslint-disable-next-line
    themeColorsCate: (state, getters, rootState, rootGetters) => {
        if(rootGetters && rootGetters["auth/config"] && rootGetters["auth/config"].new_color == 1) {
            return state.themeNewColorsCate;
        }
        return state.themeColorsCate;
    },
    themeColorsAppointment: state => state.themeColorsAppointment,
    themeColorsAnyStaff: state => state.themeColorsAnyStaff,
    serviceCommission: state => state.serviceCommission,
    productCommission: state => state.productCommission,
    giftcardCommission: state => state.giftcardCommission,
    cashCheckPercentage: state => state.cashCheckPercentage,
    // serviceInCheckin: serviceList => service => {
    //     for(let i = 0; i < serviceList.length; i++) {
    //         if(service.id == serviceList[i].id) {
    //             return true;
    //         }
    //     }
    //     return false;
    // }
    serviceListWithSearch: state => name => {
        if(name && name != '') {
            let search_arr = [];
            for(let i = 0; i < state.serviceList.length; i++) {
                let cate = state.serviceList[i];
                let service_temp = [];
                if((cate.type == 'service' || cate.type == undefined) && cate.status == 2) {
                    for(let j = 0; j < cate.services.length; j++) {
                        if(cate.services[j].name.toLowerCase().includes(name.toLowerCase()) && cate.services[j].status == 1) {
                            service_temp.push(cate.services[j]);
                        }
                    }
                    search_arr.push({id: cate.id, name: cate.name, services: service_temp, color_detail: cate.color_detail});
                }
            }
            return search_arr;
        } else {
            // return state.serviceList;
            let search_arr = [];
            for(let i = 0; i < state.serviceList.length; i++) {
                let cate = state.serviceList[i];
                let service_temp = [];
                if((cate.type == 'service' || cate.type == undefined) && cate.status == 2) {
                    for(let j = 0; j < cate.services.length; j++) {
                        if(cate.services[j].status == 1) {
                            service_temp.push(cate.services[j]);
                        }
                    }
                    search_arr.push({id: cate.id, name: cate.name, services: service_temp, color_detail: cate.color_detail});
                }
            }
            return search_arr;
        }
    },
    staffListWithSearch: state => name => {
        if(name != '') {
            let search_arr = [];
            for(let i = 0; i < state.staffList.length; i++) {
                if(state.staffList[i].name.toLowerCase().includes(name.toLowerCase())) {
                    search_arr.push(state.staffList[i]);
                }
            }
            return search_arr;
        } else {
            return state.staffList;
        }
    },
    commissionList : state => state.commissionList,

    permissionList: state => state.permissionList
}
